<!-- <mat-form-field>
<mat-label>Select a Zone</mat-label>
<mat-select [disabled]="disabled" [(value)]="zoneId">
  <mat-select-filter [array]="zones" [displayMember]="'name'" (filteredReturn)="filteredZones = $event">
  </mat-select-filter>
  <mat-option>None</mat-option>
  <mat-option [attr.style]="'padding-left: ' + ((h.indent*20)+16) + 'px'" [value]="h.id"
  *ngFor="let h of filteredZones">{{h.name}}</mat-option>
</mat-select>
</mat-form-field> -->


<div class="row">
  @for (zs of zoneSelections; track zs; let i = $index) {
    <div class="col-4">
      <mat-form-field>
        <mat-label>{{zoneTitles[i]}}</mat-label>
        <mat-select [(ngModel)]="zs.selectedZone" (selectionChange)="change(zs, i, $event)"
          [ngModelOptions]="{standalone: true}">
          @for (z of zs.zones; track z) {
            <mat-option [value]="z">{{z.name}}</mat-option>
          }
        </mat-select>
      </mat-form-field>
    </div>
  }
</div>